<template>
  <div>
    <!-- uso de la propiedad booleana de textArea para poder convertir el textfieldComp en un textarea  -->
    <template v-if="textArea">
      <v-textarea
        outlined
        :readonly="readonly"
        :disabled="disabled"
        v-model="internalValue"
        @input="updateInternalValue"
        @blur="$emit('blur', $event.target.value)"
        rows="3"
        :label="textLabel"
        :rules="rules"
      />
    </template>

    <!-- textfielcomp que se cargara por defecto al cual se le puede cambiar desde los estilos a las propiedasdes por defectos de vuetify -->
    <template v-else>
      <v-text-field
        :readonly="readonly"
        :disabled="disabled"
        v-model="internalValue"
        @input="updateInternalValue"
        @blur="$emit('blur', $event.target.value)"
        :prepend-icon="icon"
        :rules="rules"
        :type="type"
        color="primary"
        :label="textLabel"
        class="icon-size"
        hide-spin-buttons
        required
      ></v-text-field>
    </template>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      validator: function (propValue) {
        return (
          propValue === null ||
          typeof propValue === "string" ||
          typeof propValue === "number"
        );
      },
      default: null,
      required: true,
    },
    textArea: Boolean,
    readonly: Boolean,
    disabled: Boolean,

    textLabel: {
      type: String,
      default: "",
    },
    icon: {
      type: String,
    },
    type: String,

    rules: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      internalValue: this.value,
    };
  },
  watch: {
    value(newVal) {
      this.internalValue = newVal;
    },
  },

  methods: {
    updateInternalValue(newValue) {
      this.internalValue = newValue;
      this.$emit("input", newValue);


      // console.log("funciona", this.internalValue, );
    },


  },
};
</script>

<style>
/* esta clase vendria a modificar el tamaño del prepend icon de los textfield */

.icon-size .v-icon {
  font-size: 20px;
}
</style>
